import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAppContext } from "@/app/context";
import { useActiveRegistryChangeEffect } from "@/app/hooks/use-active-registry-change-effect";
import { CounterOrderDirection, RegistryCode, useOfferGroupsQuery } from "@/app/types/generated/graphql";
import { TraceXSupportedRegistries } from "@/app/types/okta.types";

import { CounteredOrdersData, GoBackPaths } from "../countered-orders/countered-orders.types";

export const useCounterOfferGroups = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const counteredRECS: CounteredOrdersData = location.state?.selectedRecs;
  const counterOrderDirection: CounterOrderDirection = location.state?.counterOrderDirection;
  const { userSelections } = useAppContext();

  const activeRegistryCode = userSelections?.registry?.registryCode as TraceXSupportedRegistries;
  const isActiveRegistryErcot = activeRegistryCode === RegistryCode.Ercot;

  const { data, loading, refetch } = useOfferGroupsQuery({
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    variables: {
      filter: {
        orderId: counteredRECS.id,
        registryCode: activeRegistryCode,
      },
    },
  });

  const goBack = useCallback(() => {
    navigate(GoBackPaths[counterOrderDirection]);
  }, [navigate, counterOrderDirection]);

  useActiveRegistryChangeEffect(goBack);

  const reloadOfferGroups = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    tableData:
      data?.offerGroups?.map((data) => ({
        ...data,
        expandedData: { offerGroupId: data.id },
      })) ?? [],
    counteredRECS,
    goBack,
    loading,
    reloadOfferGroups,
    isActiveRegistryErcot,
  };
};
